module.exports = __webpack_public_path__ + "static/media/Section-Background-Image.68a8d507.png";